import PropTypes from 'prop-types'
import classNames from 'classnames'

import LoadingSpinner from '../loader/legacy-loaders/LoadingSpinner'
import { ReactComponent as SortIcon } from '../../../assets/images/common/icons/sort-icon.svg'

import classes from './SortButton.module.scss'
import colors from '../../../assets/styles/globals.scss'

const SortButton = ({ label, active, onClick, loading }) => (
  <button className={classNames(classes.sortButton, 'd-flex align-items-center', { [classes.active]: active })} onClick={onClick} disabled={loading}>
    {label}
    {loading ? (
      <LoadingSpinner classNames={{ wrapper: classes.spinnerWrapper }} />
    ) : (
      <SortIcon className={classes.sortIcon} width={16} height={16} color={colors.slateGrayIcons} />
    )}
  </button>
)

SortButton.propTypes = {
  label: PropTypes.string,
  active: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
}

export default SortButton
